import EmployeeAdapter from './employee.adapter';

export default {
  deserialize: data => {
    return {
      employee: EmployeeAdapter.deserialize(data.employee)
    };
  }
};
